import { CareerId, careerDictionary } from '@common/const/catalog/career';
import { __experimentalFormField as FormField, withErrorTooltip } from '@cp/ds/src/components/form';
import { Select, SelectItemModel } from '@cp/ds/src/components/select';
import { Stack } from '@cp/ds/src/components/stack';
import { withProps } from '@cp/ds/src/hocs';
import { CityField } from '@cp/entities/location';
import { sentenceCase } from 'change-case';
import { PhoneOrEmail } from './phoneOrEmail';

const CareerSelect = withProps(withErrorTooltip(Select), {
  items: Object.values(careerDictionary).map<SelectItemModel<CareerId>>(({ id, translation }) => ({
    value: id as CareerId,
    label: sentenceCase(translation.nameSingle),
  })),
});

export const SearchFields = () => {
  return (
    <Stack alignItems="center" flexDirection="row" gap={1.5}>
      <CityField placeholder="Поиск города" />
      <FormField Control={CareerSelect} name="careerId" sx={{ width: 240 }} />
      <PhoneOrEmail sx={{ width: 240 }} />
    </Stack>
  );
};
